export default "__VITE_ASSET__CO_IGT0e__"